
export default [
    {
      _name: 'CSidebarNav',
      _children: [
        {
          _name: 'CSidebarNavItem',
          name: 'Dashboard',
          to: '/dashboard',
          icon: 'cil-speedometer',
          badge: {
            color: 'primary',
            text: 'NEW'
          }
        },
        {
          _name: 'CSidebarNavTitle',
          _children: ['Feature']
        },
        {
          _name: 'CSidebarNavItem',
          name: 'FAQ',
          to: '/management/faq',
          icon: 'cil-cursor'
        },
        {
          _name: 'CSidebarNavDropdown',
          name: 'About Us',
          route: '/about-us',
          icon: 'cil-drop',
          items: [
            {
              name: 'Press Release',
              to: '/about-us/press-release'
            },
          ]
        },
      ]
    }
  ]
  
  